document.addEventListener('DOMContentLoaded',function(){
  // Scroll reveal
  const rvs=document.querySelectorAll('.o-rv');
  const obs=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('o-vis')});
  },{threshold:0.1});
  rvs.forEach(r=>obs.observe(r));

  // Color swatches
  document.querySelectorAll('.o-swatch').forEach(s=>{
    s.addEventListener('click',()=>{
      document.querySelectorAll('.o-swatch').forEach(x=>x.classList.remove('o-on'));
      s.classList.add('o-on');
    });
  });
});

// Bundle selection
function oPickBundle(el){
  document.querySelectorAll('.o-bundle-card').forEach(c=>c.classList.remove('o-on'));
  el.classList.add('o-on');
}
